<template>
    <v-row>
        <v-col
            v-if="$store.get('enrollment/selected@kelon_group_id')"
            cols="12"
            md="3"
        >
            <kelon-video />
        </v-col>

        <v-col>
            <tryout-content />
        </v-col>
    </v-row>
</template>

<script>
import KelonVideo from './KelonVideo.vue'
import TryoutContent from './TryoutContent.vue'

export default {
    components: {
        TryoutContent,
        KelonVideo,
    },
}
</script>
